export const GetUpcomingEvents = "/getupcomingevents";
export const AddContactInquiry = "/addcontactinquiry";
export const GetEventDetail = "/geteventdetail";
